<template>
    <div class="upload">
        <slot name="upload_con"></slot>
        <input type="file" @change="changeFile" ref="uploadFile" :multiple="multiple" :accept="accept.join(',')" v-show="false"/>
    </div>
</template>
<script>
import { uploadQiNiuyun } from '@/components/upload/upload.js'
import axios from 'axios'
import { getAliFileUploadUrl } from '@/utils/baseUrl.js'
import { mapState } from 'vuex'
export default {
    name: 'uploadFile',
    mixins: [uploadQiNiuyun],
    props: {
        multiple: {
            type: Boolean,
            default: true
        },
        accept: {
            type: Array,
            default: () =>  ['.mp4','.mov']
        },
        uploadSize: {
            type: String,
            default: '300mb'
        },
        uploadType: {
            type: String,
            default: 'video'
        },
        autoUpload: {
            type: Boolean,
            default: true
        },
        isAddSucaiFlag: {
            type: Boolean,
            default: true
        },
        isCancelFlag: {
            type: Boolean,
            default: false
        },
        isCompressFlag: {
            type: Boolean,
            default: false
        },
        accumulate: { //是否累加上传
            type: Boolean,
            default: false
        },
        equalRatioNum: { // 压缩比率
            type: Number,
            default: 1
        },
        ishasowndrawingbedFlag: {
            type: Boolean,
            default: false
        },
        uploadTitle: {
            type: Object,
            default: () => {
                return {
                    'video': '视频',
                    'audio': '音频',
                    'img': '图片',
                    'other': '文件'
                }
            }
        },
        fileTypeObj: {
            type: Object,
            default: () => {
                return {
                    'img': 1,
                    'video': 2,
                    'audio': 3
                }
            }
        }
    },
    data() {
        return {
            uploadList: [],
            fileSizeList: [
                {
                    value: 1,
                    label: 'b'
                },
                {
                    value: 1024,
                    label: 'kb'
                },
                {
                    value: 1024 * 1024,
                    label: 'mb'
                },
                {
                    value: 1024 * 1024 * 1024,
                    label: 'gb'
                },
            ],
            observable: {},
            compressList: [
                {
                    value: 1024 *500,
                    quilty: 1
                },
                {
                    value: 1024 *1024*3,
                    quilty: 0.8
                },
                {
                    value: 1024 *1024*5,
                    quilty: 0.9
                }
            ],
            isqiniuUploadFlag: false,
            istuchuangFlag: false
        }
    },
    computed: {
         ...mapState('login', ['userInfo']),
        iSContinueUpload() {
            return this.uploadList.every(item => item.url)
        },
        requestUploadParams() {
            let params = getAliFileUploadUrl()
            let comParams = {
                ...params,
                ...params[this.uploadType]
            }
            return comParams
        },
        // 上传扩容 [讲师id]: [容量大小]
        copyuploadSize() {
			const fileSize = 
				{
					36930: '10gb',
					36329: '4gb',
                    36029: '5gb',
					8008: '5gb',
					39654: '5gb',
					36590: '5gb',
					41994: '5gb',
					37046: '5gb',
					28392: '5gb',
					40689: '5gb',
					26305: '5gb',
					43785: '8gb',
					9790: '10gb',
                    57098: '5gb',
                    57450: '3gb',
                    62212: '4gb',
                    63585: '5gb',
                    65594: '4gb',
                    67591: '10gb',
                    70990: '10gb',
                    60480: '6gb',
                    66922: '3gb',
                    72036: '10gb',
                    '72508': '5gb',
				}
            return fileSize[this.userInfo.id] && this.uploadSize === '2gb'? fileSize[this.userInfo.id] : this.uploadSize
        }
    },
    methods: {
        uploadFile() {
            this.$refs.uploadFile.click()
        },
        httprequest() {
            const instance = axios.create({
                baseURL: this.requestUploadParams.requestUrl,
                defaults: {
                    headers: {}
                }
            })
            return new Promise((resolve) => {
                instance(arguments[0]).then(res => {
                    if(res.data.code === 200) {
                        resolve(res.data.data)
                    } else {
                        this.errMessage(res.data.msg,'error')
                    }
                })
            })
        },
        async changeFile(e) {
            let files = e.target.files
            if(!this.autoUpload) {
                this.uploadList = []
            }
            if(this.uploadList.length && !this.iSContinueUpload && this.multiple) {
                setTimeout(() => {
                    e.target.value = ''
                }, 300)
                this.errMessage(`请等待当前${this.uploadTitle[this.uploadType]}上传完毕!`,'warning')
                return
            }
            if(this.uploadList.length && this.iSContinueUpload) {
                this.uploadList = []
            }
            this.handleFileList(files)
            e.target.value = ''
        },
        testFiles(files) {
            let arrFileList = []
            let typeList = ['video', 'audio']
            let i = files.length
            return new Promise((resolve) => {
                files.forEach(async (file) => {
                    let suffix = file.name.slice(file.name.lastIndexOf('.'), file.name.length)
                    suffix = suffix.toLowerCase()
                    if(file.size > this.handleFileSize()) {
                        i = i - 1
                        setTimeout(async () => {
                            await this.errMessage(`文件大小不能超过${this.uploadSize}`)
                        },0)
                    } else if(!this.accept.includes(suffix.toLocaleLowerCase())) {
                        i = i - 1
                        setTimeout(async () => {
                            await this.errMessage('上传文件格式不正确，请上传后缀名为'+ this.accept.join(',') + '文件')
                        }, 0)
                    } else {
                        let mediaObj =typeList.includes(this.uploadType) && this.staticPath === '/' ? await this.getMediaduration(file): 100
                        if(mediaObj < this.requestUploadParams.minTimes) {
                            i = i - 1
                            setTimeout(async () => {
                                await this.errMessage(file.name + '时长需大于1分钟')
                            }, 0)
                        } else {
                            let obj = {
                                name: file.name,
                                size: file.size,
                                process: 0,
                                url: '',
                                file: file,
                                type: 'pend',
                                fileType: this.fileTypeObj[this.uploadType],
                                material_size:this.toSize(file.size),
                                suffix: suffix,
                                newFileName: this.randomString(16),
                                uploadId: '',
                                uploadPath: ''
                            }
                            arrFileList.push(obj)
                            if(i == arrFileList.length) {
                                resolve(arrFileList)
                            }
                        }
                    }
                })
              
            })
        },
        async handleFileList(files) {
            let arrFileList = []
            let typeList = ['video', 'audio']
            for(let i =0;i<files.length; i++) {
                let suffix = files[i].name.slice(files[i].name.lastIndexOf('.'), files[i].name.length)
                suffix = suffix.toLowerCase()
                if(files[i].size > this.handleFileSize()) {
                   await this.errMessage(`文件大小不能超过${this.copyuploadSize}`)
                } else if(!this.accept.includes(suffix.toLocaleLowerCase())) {
                    await this.errMessage('上传文件格式不正确，请上传后缀名为'+ this.accept.join(',') + '文件')
                } else {
                    let obj = {
                        name: files[i].name,
                        size: files[i].size,
                        process: 0,
                        url: '',
                        file: files[i],
                        type: 'pend',
                        fileType: this.fileTypeObj[this.uploadType],
                        material_size:this.toSize(files[i].size),
                        suffix: suffix,
                        newFileName: this.randomString(16),
                        uploadId: '',
                        uploadPath: ''
                    }
                    // if(typeList.includes(this.uploadType)) {
                    //     let mediaObj = await this.getMediaduration(files[i])
                    //     obj = {
                    //         ...obj,
                    //         ...mediaObj
                    //     }
                    // }
                    arrFileList.push(obj)
                }
            }
            if(this.isCancelFlag) {
                this.cancelUpload()
            }
            if(!arrFileList.length) {
                return
            }
            if(this.accumulate) {
                this.uploadList = [...this.uploadList, ...arrFileList]
            } else {
                this.uploadList = arrFileList
            }
            this.$emit('beforeUpload', arrFileList)
            if(!this.autoUpload) {
                return
            }
            arrFileList.forEach(async (item, i) => {
                try {
                    if(this.accumulate) {
                        let index = this.uploadList.findIndex(obj => obj.name === item.name)
                        i = index
                    }
                    let res =  await this.httprequest({
                        method: 'get',
                        url: '/v1/ali/token',
                        data: {
                        }
                    })
                    this.uploadSdk(item.file,res,i)
                } catch (error) {
                    this.$set(item, 'type', 'error')
                }
            })
        },
        // async handleFileList(files) {
        //     let arrFileList = await this.testFiles(files) // 检测音视频时长是否满足条件
        //     if(this.isCancelFlag) {
        //         this.cancelUpload()
        //     }
        //     if(!arrFileList.length) {
        //         return
        //     }
        //     if(this.accumulate) {
        //         this.uploadList = [...this.uploadList, ...arrFileList]
        //     } else {
        //         this.uploadList = arrFileList
        //     }
        //     this.$emit('beforeUpload', arrFileList)
        //     if(!this.autoUpload) {
        //         return
        //     }
        //     arrFileList.forEach(async (item, i) => {
        //         try {
        //             if(this.accumulate) {
        //                 let index = this.uploadList.findIndex(obj => obj.name === item.name)
        //                 i = index
        //             }
        //             let res =  await this.httprequest({
        //                 method: 'get',
        //                 url: '/v1/ali/token',
        //                 data: {
        //                 }
        //             })
        //             this.uploadSdk(item.file,res,i)
        //         } catch (error) {
        //             this.$set(item, 'type', 'error')
        //         }
        //     })
        // },
        errMessage(message, type="error", duration=3000) {
            this.$message({
                type,
                duration,
                message
            })
        },
        async reloadFile(item, i=0) {
            try {
                let index = this.uploadList.findIndex(ele => ele.newFileName === item.newFileName)
                i=index !== -1? index: i
                item.type = 'pend'
                this.$set(this.uploadList, i, item)
                let res =  await this.httprequest({
                    method: 'get',
                    url: '/v1/ali/token',
                    data: {
                    }
                })
                this.uploadSdk(item.file,res,i)
            } catch (error) {
                this.$set(this.uploadList[i], 'type', 'error')
            }
        },
        handleFileSize() {
           let uploadSize = this.copyuploadSize.toLowerCase()
           let unit = uploadSize.replace(/\d/g,'')
           let uploadNum = parseInt(uploadSize)
           let obj = this.fileSizeList.find(item => item.label == unit)
           return uploadNum * obj.value
        },
        cancelUpload(index=0) {
            if(this.uploadList.length && Object.values(this.observable).length) {
                this.observable.abortMultipartUpload(this.uploadList[index].uploadPath, this.uploadList[index].uploadId)
                setTimeout(() => {
                    this.observable = {}
                })
            }
        },
        toSize(size) {
            let sizes = ''
            let fileSizeList = JSON.parse(JSON.stringify(this.fileSizeList)).reverse()
            let i = 0
            while(i< fileSizeList.length) {
                if(size > fileSizeList[i].value) {
                    sizes = (size / fileSizeList[i].value).toFixed(2) + fileSizeList[i].label.toUpperCase()
                    break;
                }
                i++
            }
            return sizes
        },

        getMediaduration(file) {
            return new Promise((resolve) => {
                let obj = {}
                var url = URL.createObjectURL(file)
                var audioElement = ''
                if(this.uploadType == 'audio') {
                    audioElement =  new Audio(url) 
                } else {
                    audioElement = document.createElement('video')
                    audioElement.src = url
                }
                audioElement.muted = true
                audioElement.play().then(() => audioElement.pause())
                audioElement.addEventListener('loadedmetadata', (e)=> {
                    // this.uploadType == 'video' ?  obj.vertically = (audioElement.videoWidth / audioElement.videoHeight).toFixed(2) >=1 ? 3:4 : ''
                    // obj.duration = parseInt(audioElement.duration)
                    resolve(parseInt(audioElement.duration))
                })
                // audioElement.muted = false
            })
        }
    },
    watch: {
        uploadList: {
            deep: true,
            handler(news) {
                this.$emit('change', news)
            }
        },
        iSContinueUpload(news) {
            this.$emit('isFinsh', news)
            if(news) {
                this.$emit('isFinshUpload', this.uploadList)
            }
        }
    }
}
</script>
<style lang="less" scoped>

</style>
